module.exports = __webpack_public_path__ + "static/media/Experiences-Icon.d77fa57e.png";